import solid from '@fortawesome/fontawesome-free-solid';
import {library} from '@fortawesome/fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(solid);

export default FontAwesomeIcon;
